import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/set1.jpg";
import about1 from "../../assets/images/banner/about1.jpg";
import about2 from "../../assets/images/banner/about2.jpg";
import about3 from "../../assets/images/banner/about3.jpg";
import about4 from "../../assets/images/banner/about4.jpg";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Crafting Timeless Jewellery, Celebrating Your Story</title>
      </Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"About us"}
        subtitle={"Our Expertise. Know more about what we do"}
      />
      <section class="story container">
        <div class="story__visual">
          <div class="story__frame">
            <div class="story__gem-display">
              <div class="gem-lg">💎</div>
              <div class="story__year">2017</div>
            </div>
            <div class="story__frame-deco"></div>
          </div>
        </div>
        <div class="story__text">
          <div class="section-header mb-3">
            <span class="section-tag">Our Beginning</span>
            <h2>A Family Legacy in Every Stone</h2>
          </div>
          <p>Maa vaishno jewellers was born from faith and forged in fire. Founded in the heart of Surat, our journey began with a simple belief — that jewellery is not just an ornament, it is a blessing passed from one generation to the next.</p>
          <p>Named after the divine Maa Vaishno Devi, our store carries the spirit of devotion into every piece we craft. From bridal sets that mark life's most sacred moments to everyday gold that brings quiet joy — we pour our heart into each creation.</p>
          <p>Three decades and thousands of smiles later, we remain committed to the values our founders lived by: pure gold, honest weights, and jewellery that tells your story.</p>
        </div>
      </section>
      <div class="quote-band">
        <blockquote>"Every stone has a secret. Our craft is to reveal it."</blockquote>
        <cite>— Rajiv Mehta, Founder</cite>
      </div>
      <section class="mission-vision container">
        <div class="mv-card mv-card--mission">
          <div class="mv-card__icon">🎯</div>
          <div class="mv-card__deco">Mission</div>
          <span class="section-tag">Our Mission</span>
          <h2>To Craft Meaning,<br /><em>Not Just Beauty</em></h2>
          <p>Our mission is to transform the finest ethically sourced materials into timeless jewelry that carries personal meaning — pieces that mark life's most cherished milestones with artistry, integrity, and soul.</p>
          <ul class="mv-list">
            <li><span class="mv-bullet">✦</span> Deliver uncompromising craftsmanship in every piece</li>
            <li><span class="mv-bullet">✦</span> Make bespoke jewelry accessible and deeply personal</li>
            <li><span class="mv-bullet">✦</span> Uphold ethical sourcing and sustainable practices</li>
            <li><span class="mv-bullet">✦</span> Build lifelong relationships with every client</li>
          </ul>
        </div>
        <div class="mv-divider">
          <div class="mv-divider__gem">💎</div>
          <div class="mv-divider__line"></div>
        </div>
        <div class="mv-card mv-card--vision">
          <div class="mv-card__icon">🔭</div>
          <div class="mv-card__deco">Vision</div>
          <span class="section-tag">Our Vision</span>
          <h2>To Become India's Most<br /><em>Trusted Jewelry House</em></h2>
          <p>We envision a future where Lumière is synonymous with legacy — a name passed down through generations, trusted for its authenticity, celebrated for its artistry, and beloved for the stories it helps tell.</p>
          <ul class="mv-list">
            <li><span class="mv-bullet">✦</span> Lead India's fine jewelry market with integrity</li>
            <li><span class="mv-bullet">✦</span> Expand bespoke services to 10 cities by 2030</li>
            <li><span class="mv-bullet">✦</span> Preserve and evolve traditional goldsmithing arts</li>
            <li><span class="mv-bullet">✦</span> Inspire the next generation of Indian artisans</li>
          </ul>
        </div>
      </section>
      <section class="about-values container">
        <div class="section-header mb-3">
          <span class="section-tag">What We Stand For</span>
          <h2>Our Principles</h2>
        </div>
        <div class="principles-grid">
          <div class="principle">
            <div className="gems mb-4">
              <img src={about1} width={"100%"} />
            </div>
            <div class="principle__num">01</div>
            <h3>BIS Hallmarked Gold</h3>
            <p>Every gram of gold we sell is BIS hallmarked and certified for purity. Choose from 18K, 22K, and 24K — because you deserve nothing less than the real thing.</p>
          </div>
          <div class="principle">
            <div className="gems mb-4">
              <img src={about2} width={"100%"} />
            </div>
            <div class="principle__num">02</div>
            <h3>Custom Bridal Designs</h3>
            <p>Your wedding is once in a lifetime — your jewellery should feel that way too. Share your vision with our designers and we'll craft a bridal set that's uniquely, beautifully yours.</p>
          </div>
          <div class="principle">
            <div className="gems mb-4">
              <img src={about3} width={"100%"} />
            </div>
            <div class="principle__num">03</div>
            <h3>Fair Exchange Policy</h3>
            <p>Got old gold sitting at home? Exchange it with us at the best current market rates. Transparent weighing, honest pricing, and instant value — no haggling, no hidden deductions.</p>
          </div>
          <div class="principle">
            <div className="gems mb-4">
              <img src={about4} width={"100%"} />
            </div>
            <div class="principle__num">04</div>
            <h3>In-Store Experience</h3>
            <p>We believe jewellery is a personal journey, not a transaction. Visit our store in Surat and take your time — our team is here to guide, not rush, you.</p>
          </div>
        </div>
      </section>
      <section class="milestones container">
        <div class="section-header">
          <span class="section-tag">The Journey</span>
          <h2>Milestones</h2>
        </div>
        <div class="timeline">
          <div class="timeline__item"> 
            <div class="timeline__year">2017</div>
            <div class="timeline__dot"></div>
            <div class="timeline__desc">Founded in a small Bihar workshop by Vinay.</div>
          </div>
          {/* <div class="timeline__item">
            <div class="timeline__year">2005</div>
            <div class="timeline__dot"></div>
            <div class="timeline__desc">Opened flagship showroom on Ring Road, Surat.</div>
          </div> */}
          <div class="timeline__item">
            <div class="timeline__year">2017</div>
            <div class="timeline__dot"></div>
            <div class="timeline__desc">Launched bespoke bridal collections.</div>
          </div>
          {/* <div class="timeline__item">
            <div class="timeline__year">2018</div>
            <div class="timeline__dot"></div>
            <div class="timeline__desc">Second generation joins. Digital consultations introduced.</div>
          </div>
          <div class="timeline__item">
            <div class="timeline__year">2024</div>
            <div class="timeline__dot"></div>
            <div class="timeline__desc">Certified as India's Top 10 Independent Jewelry Brands by JewelFest.</div>
          </div> */}
        </div>
      </section>

      <Cta />
    </div>
  );
};

export default AboutUs;
